/**
 * The status filter of Inbox → Approvals → Leave → History (manager QA,
 * 28 Oct 2026). History shows past requests, so it opens on every status,
 * not Pending (that is the "Waiting on You" view, and an approver who has
 * caught up saw "No pending requests"). The filter lives in the URL
 * (`?status=`) so Back from a request restores the list just viewed.
 *
 * Plain .ts so the node unit tests load it.
 */

export const LEAVE_LIST_STATUSES = ["all", "pending", "approved", "rejected", "cancelled"] as const;

export type LeaveListStatus = (typeof LEAVE_LIST_STATUSES)[number];

/** The History list's status: the URL value when valid, else every status. */
export function historyLeaveStatus(v: unknown): LeaveListStatus {
  return (LEAVE_LIST_STATUSES as readonly unknown[]).includes(v) ? (v as LeaveListStatus) : "all";
}

/** The `?status=` to write: none for the default (every status). */
export function historyStatusParam(s: string): { status?: LeaveListStatus } {
  const v = historyLeaveStatus(s);
  return v === "all" ? {} : { status: v };
}
